import React, { createContext, useContext, useState, useEffect } from 'react';

const TableContext = createContext();

export const useTableContext = () => {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error('useTableContext must be used within a TableProvider');
  }
  return context;
};

export const TableProvider = ({ children }) => {
  const [tableType, setTableType] = useState(() => {
    // 로컬 스토리지에서 저장된 테이블 타입 가져오기
    const savedTableType = localStorage.getItem('tableType');
    return savedTableType || 'ag-grid'; // 기본값은 'antd'
  });

  // 테이블 타입이 변경될 때마다 로컬 스토리지에 저장
  useEffect(() => {
    localStorage.setItem('tableType', tableType);
  }, [tableType]);

  const value = {
    tableType,
    setTableType,
  };

  return (
    <TableContext.Provider value={value}>
      {children}
    </TableContext.Provider>
  );
};
